t = require('views/internal/teacup-with-helpers')('power_ups_card_aging_prefs')

module.exports = t.renderable ({ agingMode, canChange }) ->
  t.h2 ->
    t.format 'how-do-you-want-the-aged-cards-to-look'

  t.ul '.pop-over-list', ->

    t.li ->
      t.a '.js-select', { href: '#', class: t.classify(disabled: !canChange), name: 'regular' }, ->

        t.span '.name', ->
          t.format 'regular-mode'

        if agingMode == 'regular'
          t.icon 'check'

        t.span '.sub-name', ->
          t.format 'older-cards-become-more-transparent'

    t.li ->
      t.a '.js-select', { href: '#', class: t.classify(disabled: !canChange), name: 'pirate' }, ->

        t.span '.name', ->
          t.format 'pirate-mode'

        if agingMode == 'pirate'
          t.icon 'check'

        t.span '.sub-name', ->
          t.format 'older-cards-crackle-and-tear'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/power_ups_card_aging_prefs.coffee